// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//SC INTEGRA-130 constantes de la aplicacion.
export const environment = {
  production: true,
  urlApiAuth: 'https://stagedev.oliverinformatica.com/NotiWebApp/Backend/api',
  urlApi: 'https://stagedev.oliverinformatica.com/NotiWebApp/Backend/public/index.php/api',
  version: '2.0.0',
  dadaKey: 'olvrdt2022',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
